<template>
  <div class="container_effects-list-card">    
    <v-card class="effects-list-card">
      <v-card-title> 
        <div class="effects-list-title mr-auto pt-1 pb-2" >Partidas pendientes de puntear</div>

        <v-tooltip top v-if="currentCompany">
          <template v-slot:activator="{ on, attrs }">
            <v-btn             
              :href="'/' + currentCompany.id +'/effects'"
              v-bind="attrs" 
              v-on="on" 
              color="primary" 
              icon 
            >
              <AppIcon :src="require('../assets/bank-btn-effects.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>              
            </v-btn>
          </template>
          <span>Listado Efectos</span>          
        </v-tooltip>
        <v-tooltip top >
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              @click="toggleSplitView()" 
              v-bind="attrs" 
              v-on="on" 
              color="primary" 
              icon 
            >
              <AppIcon :src="require('../assets/split_view_mode.svg')" :size="29" :colorMap="{ '060647': 'primary_blue' }"/>              
            </v-btn>
          </template>
          <span>Vista Columna/fila</span>          
        </v-tooltip>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="py-0 pa-0">
        <v-row  style="margin-top:13px; ">
          <app-search-bar
            :filters="listFilters"
            @updateObject="updateFilter"
            @resetAllFilters="removeAllFilt"
            :pin-state="true"
          />
        </v-row>        
        <v-row class="pa-0 ma-0" style="min-height: 64px;">
            <v-col cols="12" class="pa-2 ma-0" style="display:flex;justify-content: flex-end;">
              <template>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon 
                    @click="showDeleteEffectsPopup = true;"
                      :disabled="!(selectedEffects.length > 0)"
                      v-bind="attrs" 
                      v-on="on">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </template>
              <!-- refresh btn -->
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon 
                    @click="refreshEffects()"
                    v-bind="attrs" 
                    v-on="on">
                    <v-icon color="primary_blue">mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Refrescar</span>
              </v-tooltip>
            </v-col>
        </v-row>        
        <v-container class="pt-0">
          <v-row class="py-0 pa-0" v-if="permission.can_write">
            <v-col class="py-0 pa-0">
              <v-data-table
                class="effects-table"
                :items="screenData.effects"
                :headers="screenData.effectsHeaders"
                fixed-header
                :show-select="screenData.showSelectEffects"
                v-model="screenData.selectedEffects"
                @input="updateEff()"
                :loading="screenData.loading"   
                item-key="id"
                :footer-props="{
                  'items-per-page-options': [5, 10, 50, 100],
                  'items-per-page-text': 'Efectos por página:',
                }"
                :height="screenData.tableHeight"
                @update:items-per-page="changeLimit" 
              >
                <template v-for="header in screenData.effectsHeaders" v-slot:[`item.${header.value}`]="{ item }">
                  <span class="font-color">
                    <slot v-if="header.value == 'state'" :name="header.value" v-bind="item">
                      <v-tooltip top v-if="item[header.value] == 'no_punteado'">
                        <template v-slot:activator="{ on, attrs }">                
                          <v-icon v-bind="attrs" v-on="on">mdi-circle-outline</v-icon>
                        </template>
                        <span>No punteado</span>
                      </v-tooltip>
                      <v-tooltip top v-else-if="item[header.value] == 'punteado_parcial'">
                        <template v-slot:activator="{ on, attrs }">                
                          <v-icon color="#yellow" v-bind="attrs" v-on="on">mdi-circle-half-full</v-icon>
                        </template>
                        <span>Punteado parcialmente</span>
                      </v-tooltip>
                      <v-tooltip top v-else>
                        <template v-slot:activator="{ on, attrs }">                
                          <v-icon color="var(--v-success-base)" v-bind="attrs" v-on="on">mdi-circle</v-icon>
                        </template>
                        <span>Punteado</span>
                      </v-tooltip>
                    </slot>
                    <slot v-else-if="header.value == 'effect_type'" :name="header.value" v-bind="item">
                      <span v-if="item[header.value] == 'receivable_effect'">Cobro</span>
                      <span v-else>Pago</span>
                    </slot>
                    <slot v-else-if="header.value == 'date'" :name="header.value" v-bind="item">
                      <span>{{ changeFormat(item[header.value]) }}</span>                      
                    </slot>
                    <slot v-else-if="header.value == 'concept'" :name="header.value" v-bind="item">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">                
                          <span v-bind="attrs" v-on="on" class="limited-effect-concept">{{ item[header.value] }}</span>                      
                        </template>
                        <span class="limited-effect-concept-tooltip">{{ item[header.value] }}</span>
                      </v-tooltip>                      
                    </slot>
                    <slot v-else-if="header.value == 'origin'" :name="header.value" v-bind="item">
                      <span>{{ originTranslator(item[header.value]) }}</span>
                    </slot>
                    <slot v-else :name="header.value" v-bind="item">
                      {{ item[header.value] }}
                    </slot>
                  </span>
                </template>
            
                <!--<template v-slot:footer.prepend>                  
                  IMPORTE: {{ totalAmountEffects }}                  
                </template>-->
              </v-data-table>
            </v-col>            
          </v-row>  
          <div class="effects-total-amount"><span>Importe:</span> {{ totalAmountEffects }}</div>
        </v-container>
      </v-card-text>
    </v-card>
    <app-confirm-modal
      v-model="showDeleteEffectsPopup"
      text-msg="Se van a borrar los Efectos seleccionados."
      :loading="loadingDeleteEffects"
      @confirm="deleteEffects()"
      @cancel="showDeleteEffectsPopup = false"
    >
    </app-confirm-modal>

  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import { VuePendingEffectListScreenData } from '@/modules/effects/infra/VuePendingEffectListScreenData';
import { ApiEffectRepository } from '@/modules/effects/infra/ApiEffectRepository';
import { PendingEffectListComponent } from '@/modules/effects/app/PendingEffectsListComponent';
import JobProgress from '@/components/JobProgress.vue';
import AppDatePicker from '@/components/layout/AppDatePicker.vue';
import AppSearchBar from '@/components/layout/AppSearchBar.vue';
import AppConfirmModal from '@/components/layout/AppConfirmModal.vue'



export default {
  name: 'BankPendingEffectsTable',  
  components: {
    JobProgress,
    AppDatePicker,
    AppSearchBar,
    AppConfirmModal
  },
  computed: {
    ...mapState(['currentCompany']),    
    ...mapGetters({
      userData: 'me/userData',            
      permission: 'permissions/permission',
      got_feature:'got_feature',      
    }),
    ...mapGetters('effects', ['listFilters']),
    totalAmountEffects() {
      let total = 0
      if (this.screenData.selectedEffects.length > 0) {
        for (let f in this.screenData.selectedEffects) {
          total+=this.screenData.selectedEffects[f].amount;
        }
      }
      else {
        for (let f in this.screenData.effects) {
          total+=this.screenData.effects[f].amount;
        }
      }
      return Number(total.toFixed(2));
    }   
  },  
  props: {
    selectedTransactionsP: {
        type: Array,
        required: true
    },
    selectedEffects: {
      type: Array,
      required: true,
    }
  },
  data() {
    const screenData = new VuePendingEffectListScreenData();
    return {            
      screenData: screenData,
      effectComponent: null,
      showDeleteEffectsPopup: false,
      loadingDeleteEffects: false,
    }
  },

  async mounted() {
    let effects_repo = new ApiEffectRepository()        
    this.effectComponent = new PendingEffectListComponent(effects_repo, this.screenData)
    await this.effectComponent.mountList(this.currentCompany.id)
    this.screenData.selectedEffects = this.selectedEffects
  },

  async created() {

  },
  watch: {
    
  },
  methods: {
    ...mapActions("effects", ['updateObject','removeAllFilters']),
    async deleteEffects() {
      let selected_ids = this.getSelectedTransactions();
      try {
        this.loadingDeleteEffects = true;
        let effects_repo = new ApiEffectRepository() 
        await effects_repo.delete(selected_ids);
        this.showDeleteEffectsPopup = false;
        this.loadingDeleteEffects = false;
        this.screenData.resetSelectedEffects();
        this.updateEff();
        this.refreshEffects();
      } catch(error) {
        console.error('Error delete effects:', error);
        this.showDeleteEffectsPopup = false;
        this.loadingDeleteEffects = false;
      }
    },
    getSelectedTransactions(){
      let selected_ids = [];
      for(let i in this.selectedEffects){
        selected_ids.push(this.selectedEffects[i].id);
      }
      return selected_ids;
    },

    updateEff() {
      this.$emit('updateE', this.screenData.selectedEffects)
    },
    async updateFilter(params){
      console.log(params)
      this.updateObject(params)
      console.log(this.listFilters)
      if (this.selectedTransactionsP.length == 1) {
        this.effectComponent.mountList(this.currentCompany.id, this.selectedTransactionsP[0].id, this.listFilters)
      }
      else {
        this.effectComponent.mountList(this.currentCompany.id, null, this.listFilters)
      }
    },
    async removeAllFilt(p){
      this.removeAllFilters()
      if (this.selectedTransactionsP.length == 1) {
        this.effectComponent.mountList(this.currentCompany.id, this.selectedTransactionsP[0].id, this.listFilters)
      }
      else {
        this.effectComponent.mountList(this.currentCompany.id, null, this.listFilters)
      }
      // this.effects_component.get_effects(this.currentCompany.id, this.listFilters)      
    },
    toggleSplitView(){      
      this.$emit('toggleSplitView');
    },
    refreshEffects() {      
      if (this.selectedTransactionsP.length == 1) {
        this.effectComponent.mountList(this.currentCompany.id, this.selectedTransactionsP[0].id, this.listFilters)
      }
      else {
        this.effectComponent.mountList(this.currentCompany.id, null, this.listFilters)
      }
      this.screenData.resetSelectedEffects();
      this.updateEff();
    },
    changeFormat(dateString){
      const dateObject = new Date(dateString);
      const year = dateObject.getFullYear();
      const month = String(dateObject.getMonth() + 1).padStart(2, '0');
      const day = String(dateObject.getDate()).padStart(2, '0');
      return `${day}/${month}/${year}`;
    },
    
    changeLimit(value) {
      this.effectComponent.changeLimit(value)
    },

    originTranslator(state) {
      const fieldMap = {
          'accounting_program_effect': 'Programa contable',
          'inmatic': 'Inmatic',
          'inmatic_automatic': 'Inmatic automático',
          'excel_effect': 'Excel',
          'manual': 'Manual',
          'api': 'API'
      };

      return fieldMap[state] || state;
    },
  },
  watch: { 
    selectedTransactionsP: function(newVal, oldVal) { // watch it
      if (newVal.length == 1 || (newVal.length > 1 && oldVal.length == 1) || (newVal.length == 0 && oldVal.length == 1)) {
        if (this.selectedTransactionsP.length == 1) {
        this.effectComponent.mountList(this.currentCompany.id, this.selectedTransactionsP[0].id, this.listFilters)
        }
        else {
          this.effectComponent.mountList(this.currentCompany.id, null, this.listFilters)
        }    
      }
      console.log("PROP CHANGES");
    }
  }
}
</script> 

<style scoped> 
  .primary-bckground {
    background-color: var(--v-primary-base);
  }
  .effects-table >>> tbody td {
    font-size:12px !important;
    height: 40px !important;
  } 
  .effects-table >>> tbody td .v-icon {
    font-size: 20px !important;
  }
  .effects-table >>> thead th {
    background-color: var(--v-primaryLight-base) !important;
    color:var(--v-primary-base) !important;
  }

  .effects-table .limited-effect-concept {
    display: block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 230px;
  }

  .effects-table >>> .v-data-table__wrapper {
    scrollbar-width: thin;
  }
  .limited-effect-concept-tooltip {
    display: block;
    font-size:12px;
    width:350px; 
    max-width: 350px;
  }
  .effects-list-card {
    border-radius: 10px;
    height: 100%;
  }

  .effects-total-amount {
    position:absolute;
    bottom:30px;
    font-size: 12px;
  }
  .effects-total-amount span {
    color:var(--v-primary-base);
    font-weight: bold;
  }
  
  .container_effects-list-card {
    height: 100% !important;
  }
</style>